
import React from 'react';
import {
  FormField,
  FormItem,
  FormLabel,
  FormControl,
  FormMessage,
} from "@/components/ui/form";
import { Textarea } from "@/components/ui/textarea";
import { Checkbox } from "@/components/ui/checkbox";
import { UseFormReturn } from "react-hook-form";
import { FormValues } from "@/schemas/bilanPatrimoineSchema";

interface ObjectivesConsentSectionProps {
  form: UseFormReturn<FormValues>;
}

const ObjectivesConsentSection: React.FC<ObjectivesConsentSectionProps> = ({ form }) => {
  return (
    <>
      <FormField
        control={form.control}
        name="objectifs"
        render={({ field }) => (
          <FormItem>
            <FormLabel>Vos objectifs patrimoniaux</FormLabel>
            <FormControl>
              <Textarea
                placeholder="Décrivez vos objectifs financiers, vos projets d'investissement, vos attentes concernant le bilan patrimonial..."
                className="min-h-[120px]"
                {...field}
              />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />

      <FormField
        control={form.control}
        name="consentement"
        render={({ field }) => (
          <FormItem className="flex flex-row items-start space-x-3 space-y-0 p-4 border rounded-md">
            <FormControl>
              <Checkbox
                checked={field.value}
                onCheckedChange={field.onChange}
              />
            </FormControl>
            <div className="space-y-1 leading-none">
              <FormLabel>
                J'accepte que mes données soient traitées conformément à la politique de confidentialité
              </FormLabel>
              <FormMessage />
            </div>
          </FormItem>
        )}
      />
    </>
  );
};

export default ObjectivesConsentSection;
